import { useApi, useToast, useWorkspace } from '~/contexts';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PageLoader } from '~/routes/public/pages';

function QBORedirect() {
  const api = useApi();
  const location = useLocation();
  const { navigateWorkspace } = useWorkspace();
  const toast = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const state = new URLSearchParams(location.search).get('state');

      const workspace = await api.www.workspaces(state).get();

      try {
        await api.qbo.postRedirectUri({ uri: window.location.href });
        toast.success('Successfully connected with QuickBooks');
        await navigateWorkspace(workspace.key, '/settings/integrations/qbo?action=setup');
      } catch (error) {
        toast.error(error.message);
        await navigateWorkspace(workspace.key, '/settings/integrations');
      }
    })();
  }, [location.search, api, navigateWorkspace, toast, history]);

  return <PageLoader />;
}

export default QBORedirect;
